import React, { useEffect, useState } from 'react'
import { ErrorFlowContext, IErrorFlowContext } from './errorFlow.context'
import { ErrorFlow } from '@customTypes/errorFlow.interface'

export const CarpayErrorFlowContainer: React.FC = ({ children }) => {
    const [errorFlow, setErrorFlow] = useState<ErrorFlow>({
        lot: null,
        plate: '',
        start_datetime: undefined,
        end_datetime: undefined,
        country: '',
        selectedTariff: '',
        selectedContext: ''
    })

    useEffect(() => {
        const lotId = new URLSearchParams(location.search).get('lotId')
        const plate = new URLSearchParams(location.search).get('plate')
        const country = new URLSearchParams(location.search).get('country')

        if (lotId && plate && country) {
            // if lot in errorflow object is missing, set it
            if (!errorFlow.lot) {
                setErrorFlow((prev) => ({ ...prev, lot: { id: lotId, name: '' }, plate, country }))
            }
        }
    }, [])

    const updateErrorFlow = (newData: Partial<ErrorFlow>) => {
        setErrorFlow((prev) => ({ ...prev, ...newData }))
    }

    const context: IErrorFlowContext = {
        errorFlow,
        setErrorFlow: updateErrorFlow
    }

    return <ErrorFlowContext.Provider value={context}>{children}</ErrorFlowContext.Provider>
}
